const getSpeechSoundAudioUrl = (sound) =>
  `${
    process.env.REACT_APP_AWS_S3_BASE_URL
  }common/speechSounds/${sound.toLowerCase()}.mp3`;

export default { getSpeechSoundAudioUrl };
